import { render } from "./DefaultButton.vue?vue&type=template&id=709597d1&scoped=true&ts=true"
import script from "./DefaultButton.vue?vue&type=script&lang=ts"
export * from "./DefaultButton.vue?vue&type=script&lang=ts"

import "./DefaultButton.vue?vue&type=style&index=0&id=709597d1&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/sms-166dx-web-frontend-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709597d1"]])

export default __exports__